import { render, staticRenderFns } from "./SocketReload.vue?vue&type=template&id=738330b2&scoped=true&"
import script from "./SocketReload.vue?vue&type=script&lang=js&"
export * from "./SocketReload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738330b2",
  null
  
)

export default component.exports